<template>
  <div class="d-flex justify-center pa-4">
    <div v-if="statusCode === 404">
      <img
        src="@/assets/img/errors/error-404.png"
        class="page-error__img"
        width="100%" />
      <div class="d-flex justify-center gap-3">
        <v-btn
          href="/"
          color="primary"
          rounded
          depressed>
          <v-icon
            left
            small>
            mdi-home
          </v-icon>
          กลับสู่หน้าหลัก
        </v-btn>
      </div>
    </div>
    <div v-else-if="statusCode === 403">
      <img
        src="@/assets/img/errors/error-403.png"
        class="page-error__img"
        width="100%" />
      <div class="d-flex justify-center gap-3">
        <v-btn
          href="/"
          color="primary"
          rounded
          depressed>
          <v-icon left>
            mdi-home
          </v-icon>
          กลับสู่หน้าหลัก
        </v-btn>
        <v-btn
          :href="`https://www.${domain}/users/sign_in`"
          color="primary"
          rounded
          outlined>
          <v-icon left>
            mdi-login
          </v-icon>
          เข้าสู่ระบบ
        </v-btn>
      </div>
    </div>
    <div v-else-if="statusCode === 503">
      <img
        src="@/assets/img/errors/error-503.jpg"
        class="page-error__img"
        width="100%" />
    </div>
    <div v-else>
      <img
        src="@/assets/img/errors/error-500.png"
        class="page-error__img"
        width="100%" />
    </div>
  </div>
</template>

<script>
import psl from 'psl'

export default {
  name: 'PageError',
  props: {
    statusCode: {
      type: Number,
      default: () => 404
    }
  },
  computed: {
    domain () {
      return psl.parse(window.location.hostname).domain || 'shipnity.com'
    }
  }
}
</script>

<style>
</style>

<style lang="scss" scoped>
  .page-error {
    &__img {
      max-width: 600px;
    }
  }
</style>
